<header id="header" class="fixed-on-top header_area animated">
  <div class="row">
    <div class="col-xs-4 col-sm-2"><a routerLink="/" title="Maybank2u" class="logo navbar-logo"><img src="images/logo-black-01.svg" alt="Maybank2u"></a>
    </div>
    <div class="col-xs-8 col-sm-10">
      <div class="header-right">
        <nav>
          <ul >
            <li *ngIf="!isHome()" class="visible-sm-up" ><a routerLink="/">Home</a></li>
            <li *ngIf="isHome()" class="visible-md-up"><a routerLinkActive="active" href="#features">Features</a></li>
            <li *ngIf="isHome()" class="visible-md-up"><a href="#benefits">Benefits</a></li>
            <li *ngIf="isHome()" class="visible-md-up"><a href="#products">Our Solution</a></li>
            <li *ngIf="isHome()" class="visible-md-up"><a href="#apply">How To Apply</a></li>
            
            <!-- <li *ngIf="isHome()" class="visible-md-up"><a href="#testimonials">Testimonials</a></li> -->
            <li *ngIf="isHome()" class="visible-md-up"><a class="nav-link" href="#contact">Contact</a></li>
            <li class="visible-md-up"><a class="nav-link" href="/assets/faq/index.html">FAQ</a></li>

            <li *ngIf="authenticated" routerLink="/dashboard" routerLinkActive="active" class="visible-md-up"><a routerLink="/dashboard" title="Dashboard">Dashboard</a>
            </li>

            <li *ngIf="!authenticated" routerLink="/login" routerLinkActive="active" class="visible-md-up"><a routerLink="/login" title="Log In">Log In</a>
            </li>
            <li *ngIf="authenticated" class="visible-sm-up"><a (click)="logout()" style="cursor: pointer" title="Log Out">Log Out</a>
            </li>
          </ul>
        </nav>
        <!--<a href="http://dev.aleph-labs.com/clients/Maybank/m2u/release/demo-my/m2u/app/registration" title="Register Now" class="icon icon-register hidden-xs hidden-sm"></a><a href="javascript:;" title="Login" class="icon icon-login login-btn"></a>-->
        <a id="navbar-menu" href="javascript:;" title="" class="icon icon-menu"></a>
      </div>
    </div>
  </div>
</header>
<div id="main-nav">
  <div class="inner">
    <header><a routerLink="/" title="Register Now" class="btn btn-default has-icon hidden-md-up" (click)="close()"><i class="icon icon-register"></i><span>Maybank2u Pay</span></a><a href="javascript:;"  title="Close" class="close"></a>
    </header>
        <ul id="nav">
          <li *ngIf="!isHome()" routerLinkActive="active"><a routerLink="/" (click)="close()"><span>Home</span></a></li>
          <li *ngIf="isHome()" routerLinkActive="active"><a href="#features" (click)="close()"><span>Features</span></a></li>
          <li *ngIf="isHome()" routerLinkActive="active"><a href="#benefits" (click)="close()"><span>Benefits</span></a></li>
          
          <li *ngIf="isHome()" routerLinkActive="active"><a href="#products" (click)="close()"><span>Our Solution</span></a></li>
          <li *ngIf="isHome()" routerLinkActive="active"><a href="#apply" (click)="close()"><span>How To Apply</span></a></li>
          
          <!-- <li *ngIf="isHome()" routerLinkActive="active"><a href="#testimonials"><span>Testimonials</span></a></li> -->
          <li *ngIf="isHome()" routerLinkActive="active"><a href="#contact" (click)="close()"><span>Contact</span></a></li>

          <li *ngIf="!authenticated" routerLinkActive="active"><a routerLink="/register" (click)="close()"><span>Register</span></a></li>

          <li ><a href="/assets/faq/index.html" (click)="close()"><span>FAQ</span></a>
          </li>

          <li *ngIf="authenticated" routerLinkActive="active"><a routerLink="/dashboard" (click)="close()"><span>Dashboard</span></a>
          </li>

          <li *ngIf="!authenticated" routerLinkActive="active"><a routerLink="/login" (click)="close()" ><span>Log In</span></a></li>

          <li *ngIf="authenticated" routerLinkActive="active"><a (click)="logout()" ><span>Log Out</span></a></li>
        </ul>
    <!--<ul class="thumb-menu-list">
      <li><a href="aspire-detail.html" title="ASPIRE"><span>ASPIRE</span></a>
      </li>
      <li><a href="#" title="PREMIER WEALTH"><span>PREMIER WEALTH</span></a>
      </li>
      <li><a href="#" title="PRIVATE WEALTH"><span>PRIVATE WEALTH</span></a>
      </li>
    </ul>-->
    <!--<div class="country-selection"><a href="#" title="Malaysia" id="choose-country"><img src="images/malaysia-icon.png" alt="Malaysia"><span>Malaysia</span></a>
    </div>-->
  </div>
</div>
